import { Box, Typography } from "@mui/material";

import { ReachabilityWindowResponse } from "@/api";
import { groupReachabilityWindows } from "@/pages/priority-requests/PriorityRequests.utils";
import { useTranslation } from "@/translations";

interface Props {
  windows: ReachabilityWindowResponse[];
  align?: "left" | "right";
}

export function ReachabilityCell({ windows, align = "left" }: Props) {
  const { t } = useTranslation();

  if (windows.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("priorityRequests.noReachabilityStated")}
      </Typography>
    );
  }

  return (
    <Box
      component="dl"
      display="grid"
      gridTemplateColumns="auto 1fr"
      columnGap={1.5}
      rowGap={0.5}
      m={0}
      textAlign={align}
    >
      {groupReachabilityWindows(windows).map((day) => (
        <Box key={day.weekday} display="contents">
          <Typography component="dt" variant="body2" fontWeight="bold">
            {t(`priorityRequests.weekdays.${day.weekday}`)}
          </Typography>
          <Typography component="dd" variant="body2" m={0}>
            {day.windows}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
